import React from 'react';
import { Label } from '../../ui/label';
import { Input } from '../../ui/input';
import AddressAutocomplete from '../../AddressAutocomplete';

export default function LocationStep({
  serviceAddress,
  setServiceAddress
}) {
  return (
    <div className="animate-fade-in" data-testid="cleaning-step-3">
      <h2 className="text-2xl font-bold text-slate-900 font-['Outfit'] mb-2">Location</h2>
      <p className="text-slate-500 mb-6">Where should we come?</p>
      
      <div className="space-y-6 mb-6">
        <div>
          <Label className="text-slate-700 font-medium">Service Address</Label>
          <AddressAutocomplete
            className="mt-2"
            placeholder="Start typing your address..."
            onAddressSelect={(address) => {
              setServiceAddress({
                street: address.street || '',
                city: address.city || '',
                state: address.state || 'NJ',
                zip_code: address.zip_code || '',
                lat: address.lat || null,
                lng: address.lng || null
              });
            }}
          />
        </div>
        <div>
          <Label className="text-slate-700 font-medium">Street Address</Label>
          <Input
            value={serviceAddress.street}
            onChange={(e) => {
              // When manually entering street, keep existing lat/lng or reset if needed
              // (In the original, it defaulted to Lakewood coords, which we can keep)
              setServiceAddress(prev => ({ 
                ...prev, 
                street: e.target.value,
                // Only set default if we don't have coords yet? 
                // Or just keep them? Let's mimic original logic:
                lat: prev.lat || 40.0978,
                lng: prev.lng || -74.2177
              }));
            }}
            placeholder="123 Main Street"
            className="mt-2 h-12"
            data-testid="cleaning-street-input"
          />
        </div>
        <div className="grid grid-cols-3 gap-3">
          <div>
            <Label className="text-slate-700 font-medium">City</Label>
            <Input
              value={serviceAddress.city}
              onChange={(e) => setServiceAddress(prev => ({ ...prev, city: e.target.value }))}
              className="mt-2 h-12"
              data-testid="cleaning-city-input"
            />
          </div>
          <div>
            <Label className="text-slate-700 font-medium">State</Label>
            <Input
              value={serviceAddress.state}
              onChange={(e) => setServiceAddress(prev => ({ ...prev, state: e.target.value }))}
              className="mt-2 h-12"
              data-testid="cleaning-state-input"
            />
          </div>
          <div>
            <Label className="text-slate-700 font-medium">ZIP Code</Label>
            <Input
              value={serviceAddress.zip_code}
              onChange={(e) => setServiceAddress(prev => ({ ...prev, zip_code: e.target.value }))}
              className="mt-2 h-12"
              data-testid="cleaning-zip-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
